module.exports = __webpack_public_path__ + "870c3c25425c4f4aba1ebd6c43d20f7c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/gingerbread-house-empty.png
// module id = 2823
// module chunks = 0